import React from "react";
import ReactPlayer from "react-player";
import ErcModal from "../modules/shared/components/ErcModal";
import useWidth from "../hooks/useWidth";

export default function LongProductDescription(props) {
  const width = useWidth();

  // PROPS COMING FROM "ProductScreen"
  const { product } = props;

  return (
    <div className="product-details-description">
      <div className="w100p mh2-5r row-nowrap iyzicoButtonColor beddo-border greenbcklight hidescroll radtopleftright5r">
        <div className="w50p h100p row-center pointer">
          <ErcModal
            modalTitle={() => (
              <span className={width < 600 ? "fs-85 linkblue" : "fs1 linkblue"}>
                Teknik Özellikler
              </span>
            )}
            modalTitleFontSize={"1rem"}
            modalTitleLineHeight={"2rem"}
            contentTitle={`${product.name} | Teknik Özellikler`}
            contentTitleFontSize={"1.35rem"}
            content={[
              product.technicInfo.productSize &&
                `* ${product.technicInfo.productSize}`,
              product.technicInfo.fabricType &&
                `* ${product.technicInfo.fabricType}`,
              product.technicInfo.fabricTouch &&
                `* ${product.technicInfo.fabricTouch}`,
              product.technicInfo.fabricProductionMethod &&
                `* ${product.technicInfo.fabricProductionMethod}`,
              product.technicInfo.fabricWeight &&
                `* ${product.technicInfo.fabricWeight}`,
              product.technicInfo.fillingType &&
                `* ${product.technicInfo.fillingType}`,
              product.technicInfo.fillingProductionMethod &&
                `* ${product.technicInfo.fillingProductionMethod}`,
              product.technicInfo.ingridients &&
                `* ${product.technicInfo.ingridients}`,
              product.technicInfo.material &&
                `* ${product.technicInfo.material}`,
            ]}
            modalParagBorderBottom={"0.1rem solid #ff9935"}
            modalParagFontSize={"1.25rem"}
          />
        </div>
        <div className="w50p h100p row-center beddo-border-left pointer">
          <ErcModal
            modalTitle={() => (
              <span className={width < 600 ? "fs-85 linkblue" : "fs1 linkblue"}>
                Paket İçeriği
              </span>
            )}
            modalTitleFontSize={"1rem"}
            modalTitleLineHeight={"2rem"}
            contentTitle={`${product.name} | Paket İçeriği`}
            contentTitleFontSize={"1.35rem"}
            content={[product.boxContent && `* ${product.boxContent}`]}
            modalParagBorderBottom={"0.1rem solid #ff9935"}
            modalParagFontSize={"1.25rem"}
          />
        </div>
        {/*<div className="w50p h100p row-center beddo-border-left pointer">
          <ErcModal
            modalTitle={() => (
              <Link
                className="nodeco"
                to={`/sorucevap/${convertToUrl(product.name)}/${
                  product._id
                }?product=${product.name}?image=${product.defaultImages[0]}`}
              >
                <span
                  className={width < 600 ? "fs-85 linkblue" : "fs1 linkblue"}
                >
                  Ürün Soruları
                </span>
              </Link>
            )}
            modalTitleFontSize={"1rem"}
            modalTitleLineHeight={"2rem"}
            contentTitle={`${product.name} | Ürün Soruları`}
            contentTitleFontSize={"1.35rem"}
            content={product.productQuestions && product.productQuestions}
            modalParagBorderBottom={"0.1rem solid #ff9935"}
            modalParagFontSize={"1.25rem"}
          />
              </div>*/}
      </div>
      <h3 className="product-details-description-product-name">
        <u>{product.name}</u>
      </h3>
      <div className="product-details-description-reading-div">
        {product.longProductDescription.map((section, index) => {
          return (
            <div key={section._id} className="title-main-div">
              {section.titleMain && (
                <div>
                  <hr />
                  <h1>{section.titleMain}</h1>
                  <hr />
                </div>
              )}
              {section.titleSubs.map((titleSub, index) => {
                return (
                  <div key={index + 100} className="title-sub-div">
                    <h2>
                      <u>{titleSub}</u>
                    </h2>
                  </div>
                );
              })}
              {section.paragraphs.map((paragraph, index) => {
                return (
                  <div key={index + 200}>
                    <p>{paragraph}</p>
                  </div>
                );
              })}
              <ul>
                {section.list.map((item, index) => {
                  return (
                    item && (
                      <li key={index + 300}>
                        <i className="fas fa-square fs-65 txtmid"></i> {item}
                      </li>
                    )
                  );
                })}
              </ul>
              {section.videoUrl && (
                <div className="player-wrapper">
                  <ReactPlayer
                    className="react-player"
                    width="100%"
                    height="100%"
                    url={section.videoUrl}
                    controls={true}
                  />
                </div>
              )}
              {section.imagePath && (
                <div className="image-wrapper">
                  <img
                    className="react-player"
                    width="100%"
                    height="100%"
                    src={section.imagePath}
                    alt={product.name}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
